import { FavoritosProvider } from './../../providers/favoritos';
import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Cardapio } from '../../providers/cardapio';
import { Componentes } from '../../providers/componentes';
import { Autenticacao } from '../../providers/autenticacao';
import { PhotoViewer } from '@ionic-native/photo-viewer';

@Component({
  selector: 'page-produto',
  templateUrl: 'produto.html'
})
export class ProdutoPage {

  item: any;
  valores: any;
  categoria: any;
  valor: any;
  favorito: boolean = false;
  cliente_id: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public cardapioService: Cardapio,
    public componentes: Componentes,
    public favoritosProvider: FavoritosProvider,
    private auth: Autenticacao,
    private photoViewer: PhotoViewer
  ) {
    this.item = this.navParams.get('produto');
    this.categoria = this.navParams.get('categoria');
  }

  ionViewDidLoad() {
    this.cliente_id = this.auth.getUserId();

    if(typeof(this.cliente_id) === 'string') {
      this.favoritosProvider.verificarFavorito(this.cliente_id, this.item.produto_id).then(
        data => {
          if(data) {
            this.favorito = true;
          }
        })
    }

  }

  adicionaProduto(produto) {

    if (!this.favorito) {
      this.favoritosProvider.registrarFavorito(this.cliente_id, produto.produto_id).then(
        data => {
          this.favorito = true;
          this.componentes.apresentaToast('Você adicionou o item aos seus favoritos!');
        }, error => {
          this.componentes.apresentaToast('Ocorreu um erro ao tentar adicionar o item.');
        }
      )
    } else {
      this.favoritosProvider.removerFavorito(this.cliente_id, produto.produto_id).then(
        data => {
          this.favorito = false;
          this.componentes.apresentaToast('O item foi removido dos seus favoritos!');
        }, error => {
          this.componentes.apresentaToast('Ocorreu um erro ao tentar remover o item.');
        }
      )
    }
  }

  getFormattedPrice(price: number) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(price);
  }

  openPhoto(photo, nome) {
    this.photoViewer.show(photo, nome, {share: false});
  }
}



// WEBPACK FOOTER //
// ./src/pages/produto/produto.ts